import { request } from "../request";

/**
 * 添加盲水印
 * 返回新的图片链接
 */
export const addBlindWatermark = ({ sourceUrl }: { sourceUrl: string }) => {
    return request<{
        targetUrl: string;
    }>({
        url: "/pino_service_api/api/aliyunOss/encodeBlindWatermark",
        method: "post",
        data: {
            data: {
                sourceUrl
            },
        },
        isAuth: true,
        isEncryption: true
    });
};
